// extracted by mini-css-extract-plugin
export var readonly = "_h5-1";
export var star = "_h5-0";